import { render } from "./Department.vue?vue&type=template&id=e631b0b4"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"
script.render = render

export default script